// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"74528a8e","453":"723819c4","732":"d8c57be2","977":"6f3f3b5b"}[chunkId] + ".chunk.js";
};